module.exports = __webpack_public_path__ + "static/media/25_tn.6d6d0c9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/25_tn.jpg
// module id = 455
// module chunks = 0